import Footer from "../Common/Footer";
import Header from "../Common/Header";

import React, { useEffect } from "react";

function Terms() {
    
      useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
  return (
    <>
    <Header/>
    <div style={{backgroundImage:"url(" + "assets/img/bg/breadcumb-bg.jpg" + ")", backgroundRepeat:'no-repeat', backgroundPosition:'center center', backgroundSize:'cover'}}
      className="breadcumb-wrapper"
    
    >
      <div className="container z-index-common">
        <div className="breadcumb-content">
          <h1 className="breadcumb-title">Terms & Conditions</h1>
          
        </div>
      </div>
    </div>
    <div className="space">
      <div className="container">
        
        <div className="row">
        <div className="entry-content">
 
  <p>
    Please read these Terms of Use (“Terms”, “Terms of Use”) carefully before
    using the https://shvetdhara.com website (the “Service”) operated by Shvetdhara Dairy Foods Pvt. Ltd.
    (“us”, “we”, or “our”).
  </p>
  <p>
    Your access to and use of the Service is conditioned on your acceptance of
    and compliance with these Terms. These Terms apply to all visitors, users
    and others who access or use the Service.
  </p>
  <p>
    By accessing or using the Service you agree to be bound by these Terms. If
    you disagree with any part of the terms then you may not access the Service.
  </p>
  <h6>Accounts</h6>
  <p>
    When you create an account with us, you must provide us information that is
    accurate, complete, and current at all times. Failure to do so constitutes a
    breach of the Terms, which may result in immediate termination of your
    account on our Service.
  </p>
  <p>
    You are responsible for safeguarding the password that you use to access the
    Service and for any activities or actions under your password, whether your
    password is with our Service or a third-party service.
  </p>
  <p>
    You agree not to disclose your password to any third party. You must notify
    us immediately upon becoming aware of any breach of security or unauthorized
    use of your account.
  </p>
  <h6>Intellectual Property</h6>
  <p>
    The Service and its original content, features and functionality are and
    will remain the exclusive property of Shvetdhara Dairy Foods Pvt. Ltd. and its licensors.
  </p>
  <h6>Links To Other Web Sites</h6>
  <p>
    Our Service may contain links to third-party web sites or services that are
    not owned or controlled by Shvetdhara Dairy Foods Pvt. Ltd..
  </p>
  <p>
    Shvetdhara Dairy Foods Pvt. Ltd. has no control over, and assumes no responsibility for, the
    content, privacy policies, or practices of any third party web sites or
    services. You further acknowledge and agree that Shvetdhara Dairy Foods Pvt. Ltd. shall not be
    responsible or liable, directly or indirectly, for any damage or loss caused
    or alleged to be caused by or in connection with use of or reliance on any
    such content, goods or services available on or through any such web sites
    or services.
  </p>
  <p>
    We strongly advise you to read the terms and conditions and privacy policies
    of any third-party web sites or services that you visit.
  </p>
  <h6>Termination</h6>
  <p>
    We may terminate or suspend your account immediately, without prior notice
    or liability, for any reason whatsoever, including without limitation if you
    breach the Terms.
  </p>
  <p>
    Upon termination, your right to use the Service will immediately cease. If
    you wish to terminate your account, you may simply discontinue using the
    Service.
  </p>
  <p>
    All provisions of the Terms which by their nature should survive termination
    shall survive termination, including, without limitation, ownership
    provisions, warranty disclaimers, indemnity and limitations of liability.
  </p>
  <h6>Disclaimer</h6>
  <p>
    Your use of the Service is at your sole risk. The Service is provided on an
    “AS IS” and “AS AVAILABLE” basis. The Service is provided without warranties
    of any kind, whether express or implied, including, but not limited to,
    implied warranties of merchantability, fitness for a particular purpose,
    non-infringement or course of performance.
  </p>
  <h6>Governing Law</h6>
  <p>
    These Terms shall be governed and construed in accordance with the laws of
    India without regard to its conflict of law provisions.
  </p>
  <p>
    Our failure to enforce any right or provision of these Terms will not be
    considered a waiver of those rights. If any provision of these Terms is held
    to be invalid or unenforceable by a court, the remaining provisions of these
    Terms will remain in effect. These Terms constitute the entire agreement
    between us regarding our Service, and supersede and replace any prior
    agreements we might have between us regarding the Service.
  </p>
  <h6>Changes</h6>
  <p>
    We reserve the right, at our sole discretion, to modify or replace these
    Terms at any time. If a revision is material we will try to provide at least
    30 days notice prior to any new terms taking effect. What constitutes a
    material change will be determined at our sole discretion.
  </p>
  <p>
    By continuing to access or use our Service after those revisions become
    effective, you agree to be bound by the revised terms. If you do not agree
    to the new terms, please stop using the Service.
  </p>

   {/* ✅ NEW SECTION ADDED (CANCELLATIONS & REFUNDS) */}
              <h5 style={{marginTop: "30px"}}>Cancellations & Refunds</h5>

              <h6>Cancellation</h6>
              <p>
                After making an online subscription or payment for a particular Order/product,
                you can cancel your delivery anytime up to <strong>10:00 PM of the previous day</strong>
                 &nbsp; by creating a vacation on the platform or contacting customer support.
              </p>

              <p>
                You can also resume deliveries before the cut-off time.
              </p>

              <p>
                If any item is unavailable, we will inform you and you may cancel the order and
                receive a refund as per policy.
              </p>

              <h6>Order Cancellation by Us</h6>
              <ul>
                <li>Delivery address outside service area</li>
                <li>Unable to contact you</li>
                <li>Incomplete delivery details</li>
                <li>Items unavailable</li>
                <li>Delivery restrictions (society rules, law & order, etc.)</li>
              </ul>

              <h6>Refund</h6>
              <p>Refunds are applicable only for prepaid orders in the following cases:</p>

              <ul>
                <li>Damaged, tampered or spilled packaging (if not accepted)</li>
                <li>Order cancelled by us</li>
                <li>Order cancelled due to item unavailability</li>
              </ul>

              <p>
                Refund decisions are final and at our sole discretion.
              </p>

              <h6>Refund Process</h6>
              <ul>
                <li>Refund will be credited to your wallet</li>
                <li>You can transfer it to your bank account</li>
                <li>Processing time: 3–21 working days</li>
              </ul>

              {/* <h6>Cash on Delivery</h6>
              <ul>
                <li>No payment required for damaged or wrong orders</li>
                <li>No payment for missing items</li>
              </ul> */}

              <h6>Returns</h6>
              <ul>
                <li>Wrong product delivered</li>
                <li>Damaged or poor quality product</li>
              </ul>

              <p>
                Returns are not accepted after opening or consuming the product.
              </p>

              {/* EXISTING FINAL SECTION */}
              <h6>Contact Us</h6>
              <p>If you have any questions about these Terms, please contact us.</p>

            
  <h6>Contact Us</h6>
  <p>If you have any questions about these Terms, please contact us.</p>
</div>

        </div>
      </div>
    </div>
   
  
    <Footer />
  </>
  
  );
}

export default Terms;
